module.exports = __webpack_public_path__ + "static/media/order-operations-custom.69ea48f1.svg";